var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRoundMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 21.6634H10C9.55798 21.6634 9.13406 21.4878 8.8215 21.1753C8.50894 20.8627 8.33334 20.4388 8.33334 19.9967C8.33334 19.5547 8.50894 19.1308 8.8215 18.8182C9.13406 18.5057 9.55798 18.3301 10 18.3301H30C30.442 18.3301 30.866 18.5057 31.1785 18.8182C31.4911 19.1308 31.6667 19.5547 31.6667 19.9967C31.6667 20.4388 31.4911 20.8627 31.1785 21.1753C30.866 21.4878 30.442 21.6634 30 21.6634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundMinus);
export default __webpack_public_path__ + "static/media/ic_round-minus.26e97e7dff3b5608464f6eea6789081a.svg";
export { ForwardRef as ReactComponent };